import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Box,
  Grid,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import InputMask from "react-input-mask";
import moment from "moment";
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";

function CompletarDatosNew(props) {
  const [open, setOpen] = useState(props.open);
  const [datosRow, setDatosRow] = useState(props.rendicion || {});
  const [datosOriginales, setDatosOriginales] = useState({});
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [hojaSeleccionada, setHojaSeleccionada] = useState(null);
  const [hojaRuta, setHojaRuta] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [loadingVehiculos, setLoadingVehiculos] = useState(false);
  const [openVehiculoAutocomplete, setOpenVehiculoAutocomplete] =
    useState(false);

  const [nroRendicionValido, setNroRendicionValido] = useState(true);
const [verificandoNro, setVerificandoNro] = useState(false);
const [nroRendicionMensaje, setNroRendicionMensaje] = useState("");

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  useEffect(() => {
    getData(
      "/envasado_hoja_ruta/xsuc/" + localStorage.getItem("suc_auth").split(","),
      setHojaRuta,
    );
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

const handleNroRendicionChange = async (e) => {
  const value = e.target.value;
  setDatosRow({
    ...datosRow,
    nro_rendicion: value,
  });
  
  // Validar formato
  const formatoValido = /^\d{5}-\d{8}$/.test(value);
  
  if (formatoValido) {
    // Solo verificar si el formato es completo y válido
    await verificarNroRendicion(value);
  } else if (value && value.length > 0) {
    // Mostrar error de formato pero no verificar en la base de datos
    setNroRendicionValido(false);
    setNroRendicionMensaje("Formato inválido. Use: 12345-12345678");
  } else {
    // Campo vacío
    setNroRendicionValido(false);
    setNroRendicionMensaje("El número de rendición es requerido");
  }
};

  const isCampoOriginalCompleto = (valor) => {
    return valor && valor !== "no registrado" && valor !== "";
  };

  const parseHora = (horaString) => {
    if (!horaString || horaString === "no registrado") return null;
    return moment(horaString, "HH:mm");
  };

  const handleHoraChange = (field) => (newValue) => {
    const horaFormateada = newValue ? newValue.format("HH:mm") : "";
    setDatosRow({
      ...datosRow,
      [field]: horaFormateada,
    });
  };

  const cargarVehiculos = async () => {
    if (vehiculos.length > 0) return; // Ya cargados

    setLoadingVehiculos(true);
    try {
      const idSucursal = datosRow.sucursal_chofer || "";
      const response = await fetch(
        `${UrlApi}/vehiculos/envasadoxsucursal/${idSucursal}`,
      );
      if (response.ok) {
        const data = await response.json();
        setVehiculos(data || []);
      }
    } catch (error) {
      console.error("Error al cargar vehículos:", error);
    } finally {
      setLoadingVehiculos(false);
    }
  };

  useEffect(() => {
    if (props.rendicion) {
      setDatosRow(props.rendicion);
      setDatosOriginales(props.rendicion);
    }
  }, [props.rendicion]);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (openVehiculoAutocomplete && vehiculos.length === 0) {
      cargarVehiculos();
    }
  }, [openVehiculoAutocomplete]);

  // const getCamposModificados = () => {
  //   const modificados = {};

  //   if (datosRow.nro_rendicion !== datosOriginales.nro_rendicion) {
  //     modificados.nro_rendicion = datosRow.nro_rendicion; // Con guión
  //   }

  //   if (datosRow.vehiculo !== datosOriginales.vehiculo) {
  //     modificados.vehiculo = datosRow.vehiculo; // ID del vehículo
  //   }

  //   if (datosRow.km_inicial !== datosOriginales.km_inicial) {
  //     modificados.km_inicial = datosRow.km_inicial;
  //   }

  //   if (datosRow.km_final !== datosOriginales.km_final) {
  //     modificados.km_final = datosRow.km_final;
  //   }

  //   if (datosRow.hora_salida !== datosOriginales.hora_salida) {
  //     modificados.hora_salida = datosRow.hora_salida;
  //   }

  //   if (datosRow.hora_entrada !== datosOriginales.hora_entrada) {
  //     modificados.hora_entrada = datosRow.hora_entrada;
  //   }

  //   if (hojaSeleccionada?.id !== datosOriginales.hoja_ruta) {
  //     modificados.hoja_ruta = hojaSeleccionada?.id || null;
  //   }

  //   return modificados;
  // };


  const getCamposModificados = () => {
  const modificados = {};
  const usuario = localStorage.getItem("user") || 'Usuario desconocido';
  const cambios = []; // Array para almacenar los cambios

  if (datosRow.nro_rendicion !== datosOriginales.nro_rendicion) {
    modificados.nro_rendicion = datosRow.nro_rendicion;
    cambios.push(`Nro. Rendición: '${datosOriginales.nro_rendicion || 'Sin asignar'}' → '${datosRow.nro_rendicion}'`);
  }

  if (datosRow.vehiculo !== datosOriginales.vehiculo) {
    modificados.vehiculo = datosRow.vehiculo;
    // Intentar obtener la patente del vehículo
    const viejoVehiculo = vehiculos.find(v => v.idvehiculo === datosOriginales.vehiculo);
    const nuevoVehiculo = vehiculos.find(v => v.idvehiculo === datosRow.vehiculo);
    const viejoTexto = viejoVehiculo?.patente || datosOriginales.vehiculo || 'Sin asignar';
    const nuevoTexto = nuevoVehiculo?.patente || datosRow.vehiculo || 'Sin asignar';
    cambios.push(`Vehículo: '${viejoTexto}' → '${nuevoTexto}'`);
  }

  if (datosRow.km_inicial !== datosOriginales.km_inicial) {
    modificados.km_inicial = datosRow.km_inicial;
    cambios.push(`Km Inicial: '${datosOriginales.km_inicial || 'Sin asignar'}' → '${datosRow.km_inicial}'`);
  }

  if (datosRow.km_final !== datosOriginales.km_final) {
    modificados.km_final = datosRow.km_final;
    cambios.push(`Km Final: '${datosOriginales.km_final || 'Sin asignar'}' → '${datosRow.km_final}'`);
  }

  if (datosRow.hora_salida !== datosOriginales.hora_salida) {
    modificados.hora_salida = datosRow.hora_salida;
    cambios.push(`Hora Salida: '${datosOriginales.hora_salida || 'Sin asignar'}' → '${datosRow.hora_salida}'`);
  }

  if (datosRow.hora_entrada !== datosOriginales.hora_entrada) {
    modificados.hora_entrada = datosRow.hora_entrada;
    cambios.push(`Hora Entrada: '${datosOriginales.hora_entrada || 'Sin asignar'}' → '${datosRow.hora_entrada}'`);
  }

  if (hojaSeleccionada?.id !== datosOriginales.hoja_ruta) {
    modificados.hoja_ruta = hojaSeleccionada?.id || null;
    // Obtener nombres de las hojas de ruta
    const hojaVieja = hojaRuta.find(h => h.id === datosOriginales.hoja_ruta);
    const hojaNueva = hojaRuta.find(h => h.id === hojaSeleccionada?.id);
    const viejoTexto = hojaVieja?.patente || datosOriginales.hoja_ruta || 'Sin asignar';
    const nuevoTexto = hojaNueva?.patente || hojaSeleccionada?.id || 'Sin asignar';
    cambios.push(`Hoja Ruta: '${viejoTexto}' → '${nuevoTexto}'`);
  }

  // Agregar el detalle si hay cambios
  if (cambios.length > 0) {
    const detalleCompleto = `Usuario: ${usuario} | ` + cambios.join(' | ');
    // Truncar a 300 caracteres
    modificados.detalle = detalleCompleto.length > 300 
      ? detalleCompleto.substring(0, 297) + '...' 
      : detalleCompleto;
  }

  return modificados;
};

  const GuardarRendicion = async (e) => {
    e.preventDefault();
    // Validar número de rendición si está siendo modificado
  if (datosRow.nro_rendicion !== datosOriginales.nro_rendicion && 
      datosRow.nro_rendicion && 
      !isCampoOriginalCompleto(datosOriginales.nro_rendicion)) {
    
    const formatoValido = /^\d{5}-\d{8}$/.test(datosRow.nro_rendicion);
    
    if (!formatoValido) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Formato de número de rendición inválido. Use: 12345-12345678");
      return;
    }
    
    const existe = await verificarNroRendicion(datosRow.nro_rendicion);
    if (!existe) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("El número de rendición ya existe. Por favor, ingrese un número diferente.");
      return;
    }
  }

    setIsSaving(true);

    // Obtener solo los campos modificados
    const camposModificados = getCamposModificados();

    try {
      const payload = {
        ...camposModificados,
      };

      if (Object.keys(camposModificados).length === 0) {
        setOpenSnack(true);
        setColorMensaje("#F1948A");
        setMensaje("No se realizaron cambios para guardar");
        setIsSaving(false);
        return;
      }

      const response = await fetch(
        `${UrlApi}/envasado_rendiciones/${datosRow.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        if (camposModificados.km_final && datosRow.vehiculo) {
        try {
          const kmFinalNumber = parseInt(camposModificados.km_final, 10);
          
          // Buscar el vehículo seleccionado en la lista de vehículos
          const vehiculoSeleccionado = vehiculos.find(
            (v) => v.idvehiculo === datosRow.vehiculo
          );

          if (datosRow.vehiculo) {
            const vehiculoUpdateResponse = await fetch(
              `${UrlApi}/vehiculos/${datosRow.vehiculo}`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  kilometraje: kmFinalNumber,
                }),
              }
            );

            if (!vehiculoUpdateResponse.ok) {
              console.error("Error al actualizar el kilometraje del vehículo");
            }
          }
        } catch (error) {
          console.error("Error al actualizar kilometraje del vehículo:", error);
        }
      }
        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("La rendición se actualizó exitosamente!");
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        throw new Error("Error en la respuesta del servidor");
      }
    } catch (error) {
      console.error("Error al guardar:", error);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al actualizar la rendición");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (datosOriginales.hoja_ruta && hojaRuta.length > 0) {
      const rutaEncontrada = hojaRuta.find(
        (d) => d.id === datosOriginales.hoja_ruta,
      );
      if (rutaEncontrada) {
        setHojaSeleccionada(rutaEncontrada);
      } else {
        setHojaSeleccionada(null);
      }
    }
  }, [hojaRuta, datosOriginales.hoja_ruta]);

  const verificarNroRendicion = async (nro) => {
  // Validar formato completo antes de verificar
  const formatoValido = /^\d{5}-\d{8}$/.test(nro);
  
  if (!nro) {
    setNroRendicionValido(false);
    setNroRendicionMensaje("El número de rendición es requerido");
    return false;
  }
  
  if (!formatoValido) {
    setNroRendicionValido(false);
    setNroRendicionMensaje("Formato inválido. Use: 12345-12345678");
    return false;
  }
  
  setVerificandoNro(true);
  try {
    const response = await fetch(`${UrlApi}/envasado_rendiciones/verificar-nro/${nro}`);
    const data = await response.json();
    
    if (data.exists) {
      setNroRendicionValido(false);
      setNroRendicionMensaje(`El número de rendición ${nro} ya existe. Por favor, ingrese un número diferente.`);
      return false;
    } else {
      setNroRendicionValido(true);
      setNroRendicionMensaje("Número de rendición válido");
      return true;
    }
  } catch (error) {
    console.error("Error verificando número de rendición:", error);
    setNroRendicionValido(false);
    setNroRendicionMensaje("Error al verificar el número de rendición");
    return false;
  } finally {
    setVerificandoNro(false);
  }
};


  return (
    <>
      <Dialog fullWidth open={open} onClose={() => handleClose()} maxWidth="lg">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Completar Datos de Rendición #{datosRow.id}
            </Typography>
          </DialogTitle>
        </Box>

        <form autoComplete="off" onSubmit={GuardarRendicion}>
          <DialogContent>
            {/* Información General */}
            <Grid container spacing={1} mb={2}>
              <Grid item xs={4}>
                <TextField
                  label="Fecha"
                  size="small"
                  value={datosRow.fecha || ""}
                  fullWidth
                  InputProps={{ style: { backgroundColor: "white" } }}
                />
              </Grid>

              {/* Chofer - Siempre completo */}
              <Grid item xs={4}>
                <TextField
                  label="Chofer"
                  size="small"
                  value={datosRow.nombre_apellido || ""}
                  fullWidth
                  InputProps={{ style: { backgroundColor: "white" } }}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  label="Sucursal"
                  size="small"
                  value={datosRow.nombre_suc || ""}
                  fullWidth
                  InputProps={{ style: { backgroundColor: "white" } }}
                />
              </Grid>
            </Grid>

            {/* Campos Editables */}
            <Grid container spacing={1}>
              <Grid item xs={6} py={1}>
                {isCampoOriginalCompleto(datosOriginales.nro_rendicion) ? (
  <TextField
    label="Número de Rendición"
    size="small"
    value={datosRow.nro_rendicion || ""}
    fullWidth
    disabled
  />
) : (
  <InputMask
    mask="99999-99999999"
    value={
      datosRow.nro_rendicion !== "no registrado"
        ? datosRow.nro_rendicion
        : ""
    }
    onChange={handleNroRendicionChange}
    disabled={isCampoOriginalCompleto(
      datosOriginales.nro_rendicion,
    )}
  >
    {(inputProps) => (
      <TextField
        {...inputProps}
        label="Número de Rendición"
        name="nro_rendicion"
        size="small"
        placeholder="00000-00000000"
        fullWidth
        focused={
          !isCampoOriginalCompleto(
            datosOriginales.nro_rendicion,
          )
        }
        error={!nroRendicionValido}
        helperText={nroRendicionMensaje}
      />
    )}
  </InputMask>
)}
              </Grid>

              <Grid item xs={6} py={1}>
                {isCampoOriginalCompleto(datosOriginales.vehiculo) ? (
                  <TextField
                    label="Vehículo"
                    size="small"
                    value={datosRow.patente || ""}
                    fullWidth
                    disabled
                  />
                ) : (
                  <Autocomplete
                    options={vehiculos}
                    getOptionLabel={(option) => `${option.patente}`}
                    value={
                      vehiculos.find(
                        (v) => v.idvehiculo === datosRow.vehiculo,
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setDatosRow({
                        ...datosRow,
                        vehiculo: newValue?.idvehiculo || "",
                        patente: newValue?.patente || "",
                      });
                    }}
                    open={openVehiculoAutocomplete}
                    onOpen={() => {
                      setOpenVehiculoAutocomplete(true);
                    }}
                    onClose={() => setOpenVehiculoAutocomplete(false)}
                    loading={loadingVehiculos}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vehículo"
                        size="small"
                        focused
                        placeholder="Buscar vehículo..."
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingVehiculos ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                    fullWidth
                  />
                )}
              </Grid>

              <Grid item xs={6} py={1}>
                <TextField
                  label="Kilometraje Inicial"
                  name="km_inicial"
                  size="small"
                  placeholder="..."
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 10 }}
                  focused={!isCampoOriginalCompleto(datosOriginales.km_inicial)}
                  fullWidth
                  disabled={isCampoOriginalCompleto(datosOriginales.km_inicial)}
                  value={
                    datosRow.km_inicial !== "no registrado"
                      ? datosRow.km_inicial
                      : ""
                  }
                  onChange={almacenar}
                />
              </Grid>

              <Grid item xs={6} py={1}>
                <TextField
                  label="Kilometraje Final"
                  name="km_final"
                  size="small"
                  placeholder="..."
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 10 }}
                  focused={!isCampoOriginalCompleto(datosOriginales.km_final)}
                  fullWidth
                  // disabled={isCampoOriginalCompleto(datosOriginales.km_final)}
                  value={
                    datosRow.km_final !== "no registrado"
                      ? datosRow.km_final
                      : ""
                  }
                  onChange={almacenar}
                />
              </Grid>

              <Grid item xs={6} py={1}>
                {isCampoOriginalCompleto(datosOriginales.hora_salida) ? (
                  <TextField
                    label="Hora de Salida"
                    size="small"
                    value={datosRow.hora_salida || ""}
                    fullWidth
                    disabled
                  />
                ) : (
                  <TextField
                    label="Hora de Salida"
                    name="hora_salida"
                    type="time"
                    size="small"
                    value={
                      datosRow.hora_salida !== "no registrado"
                        ? datosRow.hora_salida
                        : ""
                    }
                    onChange={almacenar}
                    fullWidth
                    focused={
                      !isCampoOriginalCompleto(datosOriginales.hora_salida)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 minutos
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#1F618D",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: "#1F618D",
                        },
                      },
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={6} py={1}>
                {isCampoOriginalCompleto(datosOriginales.hora_entrada) ? (
                  <TextField
                    label="Hora de Entrada"
                    size="small"
                    value={datosRow.hora_entrada || ""}
                    fullWidth
                    disabled
                  />
                ) : (
                  <TextField
                    label="Hora de Entrada"
                    name="hora_entrada"
                    type="time"
                    size="small"
                    value={
                      datosRow.hora_entrada !== "no registrado"
                        ? datosRow.hora_entrada
                        : ""
                    }
                    onChange={almacenar}
                    fullWidth
                    focused={
                      !isCampoOriginalCompleto(datosOriginales.hora_entrada)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 minutos
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#1F618D",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: "#1F618D",
                        },
                      },
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  disabled={!hojaRuta}
                  required
                  id="hoja"
                  size="small"
                  noOptionsText={"hoja de Ruta INEXISTENTE"}
                  options={hojaRuta}
                  autoHighlight
                  getOptionLabel={(hoja) =>
                    hoja.patente +
                    "-" +
                    hoja.nombre +
                    "-" +
                    hoja.nombre_sucursal
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={hojaSeleccionada || null}
                  onChange={(event, value) => {
                    setHojaSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.patente} - {option.nombre} -{" "}
                      {option.nombre_sucursal}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Hoja de Ruta"
                      focused={
                        !isCampoOriginalCompleto(datosOriginales.hoja_ruta)
                      }
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={2}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                  disabled={isSaving}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button
  type="submit"
  color="success"
  variant="contained"
  disabled={
    isSaving || 
    verificandoNro || 
    (!isCampoOriginalCompleto(datosOriginales.nro_rendicion) && 
     datosRow.nro_rendicion && 
     !nroRendicionValido)
  }
>
  {isSaving ? "Guardando..." : "Guardar"}
</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CompletarDatosNew;
